import { Card, CardContent, CardHeader } from "@mui/material";
import { ReactNode } from "react";

interface CustomCartProps {
  title: string
  children?: ReactNode
}

export const DashboardCard = (props: CustomCartProps) => {
  return (
    <Card>
      <CardHeader disableTypography title={props.title} />
      <CardContent style={{ padding: 0 }}>
        {props.children}
      </CardContent>
    </Card>
  )
}